import React, { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Form, Formik, FormikHelpers } from "formik";
import * as Yup from "yup";

import { SITE_URL } from "gatsby-env-variables";
import axios from "axios";

import { useAlert } from "../../../context/AlertContext";

import useWindowDimensions from "../../../hooks/useWindowDimensions";

import { ContactMenuTypes } from "../../../types/layout";

import ICONS from "../../../constants/icons";
import ICON_SIZE from "../../icon/enums";
import { COLORS } from "../../../utils/colors";

import Icon from "../../icon/Icon";
import InputField from "../../inputs/InputField";

const contacts: ContactMenuTypes[] = [
  { id: 1, icon: ICONS.PHONE, name: "+12242765400", path: "tel:+12242765400" },
  {
    id: 2,
    icon: ICONS.EMAIL,
    name: "info@skillndepth.com",
    path: "mailto:info@skillndepth.com",
  },
  {
    id: 3,
    icon: ICONS.LOCATION,
    name: (
      <>
        <span>Einsiedlerstrasse 15b</span>
        <span> 8834 Schindellegi</span>
        <span> Switzerland</span>
      </>
    ),
    path: undefined,
  },
];

type ContactFormValues = {
  email: string;
  recaptcha?: string;
};

const ContactInfo = () => {
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  const { setAlert } = useAlert();

  const { isSmallScreen } = useWindowDimensions();

  const initialValues: ContactFormValues = {
    email: "",
    recaptcha: "",
  };

  const validation = Yup.object({
    email: Yup.string().email(),
  });

  const handleSubmit = async (
    formData: ContactFormValues,
    { resetForm }: FormikHelpers<ContactFormValues>
  ) => {
    try {
      const token = await recaptchaRef?.current?.execute();
      const data = {
        ...formData,
        recaptcha: token,
      };
      await axios({
        method: "post",
        url: `${SITE_URL}/newsletter_form.php`,
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data,
      });

      setAlert({ message: "Success", type: "success" });
      resetForm();
    } catch (error) {
      setAlert({ message: "Error", type: "error" });
    }
  };

  return (
    <div
      className={`column ${
        isSmallScreen ? "aligned-center -text-centered" : ""
      }`}
    >
      <p className={`-title footerTitle -mb15 text-white`}>
        Subscribe to our newsletter
      </p>

      <div className="-mb15">
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validation}
        >
          {({ handleSubmit }) => (
            <Form>
              <InputField
                name="email"
                placeholder="Enter your mail"
                handleClick={handleSubmit}
                buttonType="submit"
                iconColor={COLORS.white}
                aria={{
                  label: "Submit your mail",
                }}
              />
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={`${process.env.GATSBY_RECAPTCHA_SITE_KEY}`}
                size="invisible"
              />
            </Form>
          )}
        </Formik>
      </div>

      <div className="column -gap5">
        {contacts.map(({ id, icon, name, path }) => (
          <a
            href={path}
            className="m-footer__links -menu aligned-start text-white -column-gap10"
            key={id}
          >
            <Icon name={icon} size={ICON_SIZE.SIZE_16} />
            <p className="text-white column">{name}</p>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ContactInfo;
